var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c("v-card", { attrs: { "max-width": "300" } }, [
        _c(
          "div",
          { staticClass: "px-10 py-5 d-flex flex-column align-center" },
          [_c("h2", {}, [_vm._v(_vm._s(_vm.text))])]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }